import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NavigationService} from '../../../core/controller/services/navigation.service';
import {DataProviderService} from '../../../core/controller/services/data-provider.service';
import {DateService} from '../../../core/controller/services/date.service';
import {TranslateService} from '@ngx-translate/core';
import {BaseThing} from '../../base-thing';
import {GaugechartOptions} from '../../../core/view/charts/options/gaugechart-options';
import {BarchartOptions} from '../../../core/view/charts/options/barchart-options';
import {LayoutService} from '../../../core/controller/services/layout.service';
import {UserSettingsService} from '../../../core/controller/services/user-settings.service';

@Component({
    selector: 'app-olse',
    templateUrl: './olse.component.html',
    styleUrls: [
        './olse.component.scss',
        '../../../core/view/tile/tile.scss',
        '../../../../assets/css/template.scss'
    ],
    standalone: false
})
export class OlseComponent extends BaseThing implements OnInit, OnDestroy
{

    public temperatureTelescopeOptionsGauge =
        new GaugechartOptions('', '', '°C', 15, 52.5);

    public temperatureMotorOptionsGauge =
        new GaugechartOptions('', '', '°C', 15, 52.5);

    public fingerMovementOptionsBar =
        new BarchartOptions('Fingerbewegungen', '', '%',
            ['Finger 1.1', 'Finger 1.2', 'Finger 2.1', 'Finger 2.2', 'Finger 3.1', 'Finger 3.2']);

    constructor(public route: ActivatedRoute,
                private _router: Router,
                public nav: NavigationService,
                public data: DataProviderService,
                public date: DateService,
                private _translate: TranslateService,
                private _layout: LayoutService,
                private _user: UserSettingsService)
    {
        super(route, _router, nav, data, date, _translate, _layout, _user);
    }

    ngOnInit()
    {
        super.ngOnInit();
    }

    ngOnDestroy()
    {
        super.ngOnDestroy();
    }
}
